// extracted by mini-css-extract-plugin
export default {"block":"stepGhostPresentationOnly_block__LVmOC","address":"stepGhostPresentationOnly_address__ERYLF","title":"stepGhostPresentationOnly_title__9wrsz"};